// Define your array of numbers
 const numbers = [42454534750268,42692544757820,42267108180028,42267108147260,42449068982332,42448989782076,42457100025916,42449113808956,42461034643516,42475032281148,42484045217852,42460998107196,39872827359292,42461029564476];
//const numbers = [31666056134716,31666077204540];
// Save to localStorage
localStorage.setItem('FrameVariants', JSON.stringify(numbers));
